import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { toast } from '../util'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['../pages/home/home'], resolve),
      children: [
        {
          path: '',
          name: '/',
          component: resolve => require(['../pages/home/components/main'], resolve)
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['../pages/home/components/main'], resolve)
        },
        {
          path: 'tariff',
          name: 'tariff',
          component: resolve => require(['../pages/home/components/tariff'], resolve)
        },
        {
          path: 'tariffDetail/:id',
          name: 'tariffDetail',
          component: resolve => require(['../pages/home/components/tariffDetail'], resolve)
        },
        {
          path: 'product',
          name: 'product',
          component: resolve => require(['../pages/home/components/product'], resolve)
        },
        {
          path: 'member',
          name: 'member',
          component: resolve => require(['../pages/member/member'], resolve)
        },
        {
          path: 'login',
          name: 'login',
          component: resolve => require(['../pages/member/login'], resolve)
        },
        {
          path: 'register',
          name: 'register',
          component: resolve => require(['../pages/member/register'], resolve)
        },
        {
          path: 'forgot',
          name: 'forgot',
          component: resolve => require(['../pages/member/forgot'], resolve)
        },
        {
          path: 'datum',
          name: 'datum',
          component: resolve => require(['../pages/member/datum'], resolve)
        },
        {
          path: 'upPass',
          name: 'upPass',
          component: resolve => require(['../pages/member/upPass'], resolve)
        },
        {
          path: 'queryHistory',
          name: 'queryHistory',
          component: resolve => require(['../pages/member/queryHistory'], resolve)
        },
        {
          path: 'vipPrice',
          name: 'vipPrice',
          component: resolve => require(['../pages/vip/vipPrice'], resolve)
        },
        {
          path: 'vipPay',
          name: 'vipPay',
          component: resolve => require(['../pages/vip/vipPay'], resolve)
        },
        {
          path: 'paySuccess',
          name: 'paySuccess',
          component: resolve => require(['../pages/vip/paySuccess'], resolve)
        },
        {
          path: 'vipOrder',
          name: 'vipOrder',
          component: resolve => require(['../pages/about/vipOrder'], resolve)
        },
        {
          path: 'note',
          name: 'note',
          component: resolve => require(['../pages/cate/note'], resolve)
        },
        {
          path: 'noteshow/:id',
          name: 'noteshow',
          component: resolve => require(['../pages/cate/noteshow'], resolve)
        },
        {
          path: 'service',
          name: 'service',
          component: resolve => require(['../pages/service/service'], resolve)
        },
        {
          path: 'serviceDetail/:id',
          name: 'serviceDetail',
          component: resolve => require(['../pages/service/serviceDetail'], resolve)
        },
        {
          path: 'resolve',
          name: 'resolve',
          component: resolve => require(['../pages/cate/resolve'], resolve)
        },
        {
          path: 'resolveDetail/:id',
          name: 'resolveDetail',
          component: resolve => require(['../pages/cate/resolveDetail'], resolve)
        },
        {
          path: 'rule',
          name: 'rule',
          component: resolve => require(['../pages/cate/rule'], resolve)
        },
        {
          path: 'ruleDetail/:id',
          name: 'ruleDetail',
          component: resolve => require(['../pages/cate/ruleDetail'], resolve)
        },
        {
          path: 'zero',
          name: 'zero',
          component: resolve => require(['../pages/cate/zero'], resolve)
        },
        {
          path: 'forbidden',
          name: 'forbidden',
          component: resolve => require(['../pages/cate/forbidden'], resolve)
        },
        {
          path: 'cas',
          name: 'cas',
          component: resolve => require(['../pages/cate/cas'], resolve)
        },
        {
          path: 'casDetail/:id',
          name: 'casDetail',
          component: resolve => require(['../pages/cate/casDetail'], resolve)
        },
        {
          path: 'casDg',
          name: 'casDg',
          component: resolve => require(['../pages/cate/casDg'], resolve)
        },
        {
          path: 'casDgDetail/:id',
          name: 'casDgDetail',
          component: resolve => require(['../pages/cate/casDgDetail'], resolve)
        },
        {
          path: 'cateArticle/:id',
          name: 'cateArticle',
          component: resolve => require(['../pages/cate/cateArticle'], resolve)
        },
        {
          path: 'download',
          name: 'download',
          component: resolve => require(['../pages/about/download'], resolve)
        },
        {
          path: 'aboutUs',
          name: 'aboutUs',
          component: resolve => require(['../pages/about/aboutUs'], resolve)
        },
        {
          path: 'dumpSub',
          name: 'dumpSub',
          component: resolve => require(['../pages/home/components/dumpSub'], resolve)
        },
        {
          path: 'comArticle',
          name: 'comArticle',
          component: resolve => require(['../pages/common/comArticle'], resolve)
        },
        {
          path: 'ciqCode',
          name: 'ciqCode',
          component: resolve => require(['../pages/cate/ciqCode'], resolve)
        },
        {
          path: 'more',
          name: 'more',
          component: resolve => require(['../pages/more'], resolve)
        },
        {
          path: 'areaCode',
          name: 'areaCode',
          component: resolve => require(['../pages/more/areaCode'], resolve)
        },
        {
          path: 'portCode',
          name: 'portCode',
          component: resolve => require(['../pages/more/portCode'], resolve)
        },
        {
          path: 'threeC',
          name: 'threeC',
          component: resolve => require(['../pages/more/threeC'], resolve)
        },
        {
          path: 'status',
          name: 'status',
          component: resolve => require(['../pages/more/status'], resolve)
        },
        {
          path: 'calculation',
          name: 'calculation',
          component: resolve => require(['../pages/more/calculation'], resolve)
        },
        {
          path: 'commonly',
          name: 'commonly',
          component: resolve => require(['../pages/more/commonly'], resolve)
        },
        {
          path: 'dictuse',
          name: 'dictuse',
          component: resolve => require(['../pages/more/commonly/dictuse'], resolve)
        },
        {
          path: 'tax',
          name: 'tax',
          component: resolve => require(['../pages/more/commonly/tax'], resolve)
        },
        {
          path: 'currency',
          name: 'currency',
          component: resolve => require(['../pages/more/commonly/currency'], resolve)
        },
        {
          path: 'mode',
          name: 'mode',
          component: resolve => require(['../pages/more/commonly/mode'], resolve)
        },
        {
          path: 'cert',
          name: 'cert',
          component: resolve => require(['../pages/more/commonly/cert'], resolve)
        },
        {
          path: 'package',
          name: 'package',
          component: resolve => require(['../pages/more/commonly/package'], resolve)
        },
        {
          path: 'city',
          name: 'city',
          component: resolve => require(['../pages/more/commonly/city'], resolve)
        },
        {
          path: 'deal',
          name: 'deal',
          component: resolve => require(['../pages/more/commonly/deal'], resolve)
        },
        {
          path: 'measure',
          name: 'measure',
          component: resolve => require(['../pages/more/commonly/measure'], resolve)
        },
        {
          path: 'transport',
          name: 'transport',
          component: resolve => require(['../pages/more/commonly/transport'], resolve)
        },
        {
          path: 'nation',
          name: 'nation',
          component: resolve => require(['../pages/more/commonly/nation'], resolve)
        },
        {
          path: 'reduction',
          name: 'reduction',
          component: resolve => require(['../pages/more/commonly/reduction'], resolve)
        },
        {
          path: 'trade',
          name: 'trade',
          component: resolve => require(['../pages/more/commonly/trade'], resolve)
        },
        {
          path: 'domestic',
          name: 'domestic',
          component: resolve => require(['../pages/more/commonly/domestic'], resolve)
        },
        {
          path: 'reasons',
          name: 'reasons',
          component: resolve => require(['../pages/more/commonly/reasons'], resolve)
        },
        {
          path: 'permit',
          name: 'permit',
          component: resolve => require(['../pages/more/commonly/permit'], resolve)
        },
        {
          path: 'danger',
          name: 'danger',
          component: resolve => require(['../pages/more/commonly/danger'], resolve)
        },
        {
          path: 'container',
          name: 'container',
          component: resolve => require(['../pages/more/commonly/container'], resolve)
        },
        {
          path: 'property',
          name: 'property',
          component: resolve => require(['../pages/more/commonly/property'], resolve)
        },
        {
          path: 'transport_cus',
          name: 'transport_cus',
          component: resolve => require(['../pages/more/commonly/transport_cus'], resolve)
        },
        {
          path: 'transport_ins',
          name: 'transport_ins',
          component: resolve => require(['../pages/more/commonly/transport_ins'], resolve)
        },
        {
          path: 'mode_cus',
          name: 'mode_cus',
          component: resolve => require(['../pages/more/commonly/mode_cus'], resolve)
        },
        {
          path: 'mode_ins',
          name: 'mode_ins',
          component: resolve => require(['../pages/more/commonly/mode_ins'], resolve)
        },
        {
          path: 'nation_cus',
          name: 'nation_cus',
          component: resolve => require(['../pages/more/commonly/nation_cus'], resolve)
        },
        {
          path: 'nation_ins',
          name: 'nation_ins',
          component: resolve => require(['../pages/more/commonly/nation_ins'], resolve)
        },
        {
          path: 'port_cus',
          name: 'port_cus',
          component: resolve => require(['../pages/more/commonly/port_cus'], resolve)
        },
        {
          path: 'port_ins',
          name: 'port_ins',
          component: resolve => require(['../pages/more/commonly/port_ins'], resolve)
        },
        {
          path: 'currency_cus',
          name: 'currency_cus',
          component: resolve => require(['../pages/more/commonly/currency_cus'], resolve)
        },
        {
          path: 'currency_ins',
          name: 'currency_ins',
          component: resolve => require(['../pages/more/commonly/currency_ins'], resolve)
        },
        {
          path: 'container_cus',
          name: 'container_cus',
          component: resolve => require(['../pages/more/commonly/container_cus'], resolve)
        },
        {
          path: 'container_ins',
          name: 'container_ins',
          component: resolve => require(['../pages/more/commonly/container_ins'], resolve)
        },
        {
          path: 'package_cus',
          name: 'package_cus',
          component: resolve => require(['../pages/more/commonly/package_cus'], resolve)
        },
        {
          path: 'package_ins',
          name: 'package_ins',
          component: resolve => require(['../pages/more/commonly/package_ins'], resolve)
        }
      ]
    },
    {
      path: '/chat',
      name: 'chat',
      component: resolve => require(['../pages/chat'], resolve)
    },
    {
      path: '/loginLoading',
      name: 'loginLoading',
      component: resolve => require(['../pages/member/loginLoading'], resolve)
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  let uncheck = ['login', 'loginLoading', 'home', '/', 'register', 'goods', 'service', 'serviceDetail', 'download', 'forgot', 'cateArticle', 'casDgDetail', 'casDg', 'casDetail', 'cas', 'forbidden', 'zero', 'rule', 'ruleDetail', 'resolveDetail', 'forbidden', 'resolve', 'note', 'aboutUs']
  let login = store.state.user.isLogin
  if (uncheck.indexOf(to.name) === -1 && !login) {
    let path = to.path.replace('/', '')
    // 设置当前路由信息，供登录成功后跳转
    store.commit('setGoToUrl', path)
    toast('请先登录')
    next('login')
  } else {
    if (to.name === 'login' && login) {
      next('home')
    } else {
      next()
    }
  }
})

router.afterEach((to) => {
  // 谷歌
  if (window.ga) {
    window.ga('set', 'page', to.fullPath)
    window.ga('send', 'pageview')
  }

  // 百度
  /* let _hmt = _hmt || [];
  (function () {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?5dd18ee1cf7f41a8cf1ad6dc20dbe0cc'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })() */
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js